<template>
  <div class="order-details">
    <v-card class="card">
      <h2 class="order-summary__title">
        {{ $t("message.payments.paymentDetails") }}
      </h2>

      <PaymentForm />
    </v-card>
  </div>
</template>

<script>
import PaymentForm from "@/components/Payments/PaymentForm.vue";
export default {
  name: "Checkout",
  components: {
    PaymentForm
  }
};
</script>

<style lang="scss" scoped>
.order-details {
  display: flex;
  flex-direction: column;
  gap: $spacing * 3;

  &__submit {
    align-self: flex-end;
  }
}
.header {
  display: flex;
  align-items: center;
  gap: $spacing * 2.5;

  &__title {
    @include font-size(30px);
  }
}
.card {
  padding: 3 * $spacing 4 * $spacing;
  display: flex;
  flex-direction: column;
  gap: $spacing * 2;
  height: auto;
}

.order-summary {
  background: rgba($gray-300, 0.2);
  padding: $spacing * 2.5;
  display: flex;
  gap: $spacing * 3;
  flex-direction: column;
  border-radius: 7px !important;

  &__title {
    @include font-size(24px);
  }

  &__total-price {
    padding: $spacing * 3 0 $spacing * 0.5 0;
    border-top: 1px solid $gray-300;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include font-size(20px);

    * {
      line-height: 1em;
    }

    span {
      @include font-size(14px);
    }
  }
}
</style>
